export const appCachedKeys = {
    DM_CHIENDICH_SELECTED: "DM_CHIENDICH_SELECTED",
    HOCSINH_FILTER: "HOCSINH_FILTER"
}
export const appCached = {
    GET: (key) => {
        const dataJson = localStorage.getItem(key);
        if (dataJson) {
            try {
                return JSON.parse(dataJson);
            } catch (error) {
                return null;
            }
        }
        return null;
    },
    SET: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
    DELETE: (key) => localStorage.removeItem(key)
}